export const MANUAL_ATTEMPT_KEY = "manual";

// Statuses that indicate a verdict has been set (passed or failed).
export const REVIEWED_STATUSES = ["passed", "failed"];

// Statuses that allow an admin to interact with the assignment on an attempt tab.
export const ADMIN_REVIEWABLE_STATUSES = ["pending_review", ...REVIEWED_STATUSES];

export type SaveRoute = "manual" | "adminOverride" | "attemptReview";
export const SAVE_ROUTES = {
  manual: "manual",
  adminOverride: "adminOverride",
  attemptReview: "attemptReview",
} as const satisfies Record<string, SaveRoute>;
